module.exports = __webpack_public_path__ + "img/refresh-ccw-02.70b9abf3.svg";